import Overview from './overview.vue';
import MobOverview from '@rebuild/materials/shared/custom/MobOverview.vue';
import MobFull from '@rebuild/materials/shared/custom/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 